const cookieKey = 'ss_token';

export const setCookie = function (data) {
    let value = data.token || '';
    localStorage.setItem(cookieKey, value);
};

export const getCookie = function () {
    return localStorage.getItem(cookieKey);
};

export const delCookie = function () {
    localStorage.removeItem(cookieKey);
    document.cookie = `${cookieKey}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;`;
};
